module.exports = __webpack_public_path__ + "img/0009.f7f83098.png";